import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import React from 'react'

const Seo = ({
  canonicalUrl,
  metaTitle,
  metaDescription,
  ogTitle,
  ogDescription,
  ogImage,
}) => {
  const location = useLocation()

  // Default to current path if canonicalUrl not provided
  const finalCanonical =
    canonicalUrl || `${window.location.origin}${location.pathname}`

  return (
    <Helmet>
      {/* Canonical URL - always include */}
      <link rel="canonical" href={finalCanonical} />

      {/* Standard meta tags */}
      {metaTitle && <meta name="title" content={metaTitle} />}
      <meta
        name="description"
        content={metaDescription || 'Default description'}
      />

      <meta property="og:url" content={finalCanonical} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={ogTitle || metaTitle || 'Default Title'}
      />
      <meta
        property="og:description"
        content={ogDescription || metaDescription || 'Default description'}
      />
      {ogImage && <meta property="og:image" content={ogImage} />}
    </Helmet>
  )
}

export default Seo
